const FILES = require('./sounds.json')

const SOUNDS = new Map(
  [
    ['ringback', { audio: new Audio(FILES['ringback']), volume: 1.0 }],
    ['ringing', { audio: new Audio(FILES['ringing']), volume: 1.0 }],
    ['answered', { audio: new Audio(FILES['answered']), volume: 1.0 }],
    ['rejected', { audio: new Audio(FILES['rejected']), volume: 0.5 }],
    ['failed', { audio: new Audio(FILES['failed']), volume: 0.6 }]
  ])

class AudioPlayer {
  constructor() {
    this.initialized = false
  }
  initialize () {
    if (this.initialized) { return }
    for (const sound of SOUNDS.values()) {
      sound.audio.volume = 0
      try {
        sound.audio.play()
      } catch (error) {
        console.error(error)
      }
    }
    this.initialized = true
  }
  play (name, relativeVolume, loop) {
    this.initialize()

    if (typeof relativeVolume !== 'number') { relativeVolume = 1.0 }

    // logger.debug('Audio play() [name:%s, relativeVolume:%s]', name, relativeVolume)

    const sound = SOUNDS.get(name)

    if (!sound) { throw new Error(`unknown sound name "${name}"`) }

    try {
      sound.audio.pause()
      sound.audio.currentTime = 0.0
      sound.audio.volume = (sound.volume || 1.0) * relativeVolume
      sound.audio.loop = loop ? loop : false
      sound.audio.playbackRate = name === 'ringback' ? 1.3 : 1
      sound.audio.play()
    } catch (error) {
      console.warn('play() | error: %o', error)
    }
  }

  stop (name) {
    console.debug('stop() [name:%s]', name)

    const sound = SOUNDS.get(name)

    if (!sound) { throw new Error(`unknown sound name "${name}"`) }

    sound.audio.pause()
    sound.audio.currentTime = 0.0
  }

  playOnce (name, relativeVolume) {
    this.initialize()

    if (typeof relativeVolume !== 'number') { relativeVolume = 1.0 }

    // logger.debug('Audio play() [name:%s, relativeVolume:%s]', name, relativeVolume)

    const sound = SOUNDS.get(name)

    if (!sound) { throw new Error(`unknown sound name "${name}"`) }

    try {
      sound.audio.pause()
      sound.audio.currentTime = 0.0
      sound.audio.volume = (sound.volume || 1.0) * relativeVolume
      sound.audio.loop = false
      sound.audio.playbackRate = name === 'ringback' ? 1.3 : 1
      sound.audio.play()
    } catch (error) {
      console.warn('play() | error: %o', error)
    }
  }

  playAudio (audio, relativeVolume, loop) {
    this.initialize()

    if (typeof relativeVolume !== 'number') { relativeVolume = 1.0 }
    if (!audio) { throw new Error(`unknown audio "${audio}"`) }
    try {
      audio.pause()
      audio.currentTime = 0.0
      audio.volume = relativeVolume
      audio.loop = loop ? loop : false
      audio.playbackRate = 1
      audio.play()
    } catch (error) {
      console.warn('play() | error: %o', error)
    }
  }

  stopAudio (audio) {
    audio.pause()
    audio.currentTime = 0.0
  }
}
export default AudioPlayer